import { Pipe, PipeTransform } from '@angular/core';
import { StepTemplateContextInput, StepTemplateContextOutput } from '../contract/step-template-context.contract';
import { StepperComponent } from '../stepper.component';


@Pipe({
  name: 'stepTemplateContext',
  standalone: true
})
export class StepTemplateContextPipe implements PipeTransform {

  transform(context: StepTemplateContextInput, stepper: StepperComponent): StepTemplateContextOutput {
    const { index, active, highlighted, isValid } = context;
    return {
      index, active, highlighted, isValid,
      prevCallback: () => stepper.updateActiveStep(index - 1),
      nextCallback: () => stepper.updateActiveStep(index + 1),
    }
  }

}
